import { USER_LOGIN, USER_SIGNUP, FORGOT_PASSWORD, RESET_PASSWORD, BEFORE_USER, BEFORE_USER_PLAN, GET_USER, GET_PLAN_DETAILS, UPDATE_PROFILE } from '../../../redux/types';

const initialState = {
    userData: null,
    userAuth: false,

    userSignupData: null,
    userSignupAuth: false,

    forgotPasswordData: null,
    forgotPasswordAuth: false,

    resetPasswordData: null,
    resetPasswordAuth: false,

    getUserData: null,
    getUserAuth: false,

    updateProfileData: null,
    updateProfileAuth: false,

    userPlanDetailsData: null,
    userPlanDetailsAuth: false
}

export default function userRed(state = initialState, action) {
    switch (action.type) {
        case USER_LOGIN:
            return {
                ...state,
                userData: action.payload,
                userAuth: true
            }
        case USER_SIGNUP:
            return {
                ...state,
                userSignupData: action.payload,
                userSignupAuth: true
            }

        case FORGOT_PASSWORD:
            return {
                ...state,
                forgotPasswordData: action.payload,
                forgotPasswordAuth: true
            }

        case RESET_PASSWORD:
            return {
                ...state,
                resetPasswordData: action.payload,
                resetPasswordAuth: true
            }
        case GET_USER:
            return {
                ...state,
                getUserData: action.payload,
                getUserAuth: true
            }
        case GET_PLAN_DETAILS:
            return {
                ...state,
                userPlanDetailsData: action.payload,
                userPlanDetailsAuth: true
            }
        case UPDATE_PROFILE:
            return {
                ...state,
                updateProfileData: action.payload,
                updateProfileAuth: true
            }
        case BEFORE_USER:
            return {
                ...state,
                userData: null,
                userAuth: false,

                userSignupData: null,
                userSignupAuth: false,

                forgotPasswordData: null,
                forgotPasswordAuth: false,

                resetPasswordData: null,
                resetPasswordAuth: false,

                getUserData: null,
                getUserAuth: false,

                updateProfileData: null,
                updateProfileAuth: false,

                userPlanDetailsData: null,
                userPlanDetailsAuth: false
            }
        case BEFORE_USER_PLAN:
            return {
                ...state,
                userPlanDetailsData: null,
                userPlanDetailsAuth: false
            }
        default:
            return {
                ...state
            }
    }
}